/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-04-16 10:08:26
 * @LastEditTime : 2025-07-15 10:26:04
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\components_data\dataCompletionNew.js
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/handOverInformationV2/queryPage";
export const exportHandOver = "/icps/system/sign/basics/handOverInformationV2/exportHandOver";
/*修改交工资料*/
export function deleteHandOverData(data) {
    return request({
      url: "/icps/system/sign/basics/handOverInformationV2/deleteHandOverData",
      method: "post",
      data,
    });
  }
/*获取标号工程配合比设置*/
export function getEngineerMixDetail(data) {
    return request({
      url: "/icps/system/sign/basics/handOverInformationV2/getEngineerMixDetail",
      method: "post",
      data,
    });
  }
/*匹配配合比库*/
export function matchMixRatio(data) {
    return request({
      url: "/icps/system/sign/basics/handOverInformationV2/matchMixRatio",
      method: "post",
      data,
    });
  }
/*保存标号配合比*/
export function saveMixRatio(data) {
    return request({
      url: "/icps/system/sign/basics/handOverInformationV2/saveMixRatio",
      method: "post",
      data,
    });
  }
/*获取已保存厂家信息 -已配置*/
export function queryManufacturer(data) {
    return request({
      url: "/icps/system/sign/basics/handOverInformationV2/queryManufacturer",
      method: "post",
      data,
    });
  }
/*获取厂家信息 -待配置*/
export function matchMixRatioMaterials(data) {
    return request({
      url: "/icps/system/sign/basics/handOverInformationV2/matchMixRatioMaterials",
      method: "post",
      data,
    });
  }
/*新增或修改厂家信息*/
export function saveManufacturer(data) {
    return request({
      url: "/icps/system/sign/basics/handOverInformationV2/saveManufacturer",
      method: "post",
      data,
    });
  }
/*点击配合比选择带出试验内容*/
export function getPourParts(data) {
    return request({
      url: "/icps/system/sign/basics/handOverInformationV2/getPourParts",
      method: "post",
      data,
    });
  }